import React, { useCallback, useEffect, useState } from "react";
import {
  Paper,
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  Divider,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stack,
  Modal,
  Typography,
  alpha,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";

import "./mywallet.css";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import ModalContent from "../../Common/Modal";
import InfoPopUp from "../../Common/InfoPopUp";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import InfoIcon from "@mui/icons-material/Info";

const FUTUREMARGINURL = WEBSERVICE + "/fMargin/";

const FiatSpotColumn = ["Fiat", "Amount", "Transfer To"];
const FiatMarginColumn = [
  "Fiat",
  "Margin Wallet Balance",
  "Used Balance",
  "Available Balance",
  "Transfer To",
];
const AssetSpotColumn = ["Asset", "Balance", "Action"];

const Infomodal = [
  {
    title: "Isolated",
    description:
      "Isolated Margin is the margin balance allocated to an individual position. Isolated Margin mode allows traders to manage their risk on their individual positions by restricting the amount of margin allocated to each one. The allocated margin balance for each position can be individually adjusted.",
  },
  {
    title: "Cross",
    description:
      "Cross Wallet is a crypto wallet built to hold multiple blockchain cryptocurrencies in one wallet.",
  },
  {
    title: "Fiat Holdings",
    description:
      "You can do margin and funding in your fiat currency from this section.",
  },
  {
    title: "SPOT WALLET",
    description:
      "You can see your fiat balance, transfer to margins, and fund your fiat through SPOT WALLET.",
  },
  {
    title: "MARGIN WALLET",
    description:
      "You can see your margin wallet balance, used balance, and available margin wallet balance. You can transfer your margin wallet balance to your spot wallet through the transfer to SPOT button ",
  },
  {
    title: "Funding",
    description:
      "You can see your funding here by providing From Date and To Date.",
  },
  {
    title: "Crypto Holdings",
    description:
      "You can do margin and funding in your Cryptocurrency from this section.",
  },
  {
    title: "Transfer to SPOT",
    description:
      "You can transfer your margin wallet balance to the spot wallet through this SPOT button.",
  },
  {
    title: "Margin",
    description:
      "You can transfer your fiat balance to your Margin Wallet through this Margin button.",
  },
  {
    title: "Funding",
    description:
      "You can transfer your fiat balance to Funding Wallet through this Funding button. ",
  },
  {
    title: "MARGIN",
    description:
      "You can transfer your Crypto balance to your Margin Wallet through this Margin link.",
  },
  {
    title: "Funding",
    description:
      "You can transfer your Crypto balance to your Funding Wallet through this Funding link.",
  },
  {
    title: "Portfolio",
    description:
      "You can see your balances on a contract basis (Perpetual, Quarterly).",
  },
  {
    title: "SPOT WALLET",
    description:
      "You can see your Crypto balance, transfer to margins, and fund your Crypto through SPOT WALLET.",
  },
  {
    title: "MARGIN",
    description:
      "You can see your margin wallet balance, used balance, and available margin wallet balance. You can transfer your margin wallet balance to your spot wallet through the transfer to SPOT button.",
  },
  {
    title: "VIEW MY FUNDINGS",
    description:
      "You can see your Fundings here by selecting currency and providing From Date and To Date.",
  },
];

const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "start",
  borderBottom: "2px solid #616266",
  padding: "16px",
};

const bodyStyle = {
  padding: "16px",
  textAlign: "left",
};

const MyWalletFuture = () => {
  const navigate = useNavigate();
  const { btncolor } = useSelector((state) => state);
  const theme = localStorage.getItem("theme");
  const selectedLeverageType =
    localStorage.getItem("selected_leverage_future")?.slice(0, -1) || 2;
  const [selectedMarginType, setSelectedMarginType] = useState(1);
  const [value, setValue] = useState(0);
  const [fiatTab, setFiatTab] = useState("SPOT WALLET");
  const [assetTab, setAssetTab] = useState("SPOT WALLET");
  const [portfolioTab, setPortfolioTab] = useState();
  const [fromData, setFromDate] = useState(null);
  const [toData, setToDate] = useState(null);
  const [returnDate, setReturnDate] = useState(null);
  const [assetFromData, setAssetFromDate] = useState(null);
  const [assetToData, setAssetToDate] = useState(null);
  const [currency, setCurrency] = useState("");
  const [assetCurrency, setAssetCurrency] = useState("");
  const [selected, setSelected] = useState("Isolated");
  const [marginModal, setMarginModal] = useState(false);
  const [fundingModal, setFundingModal] = useState(false);
  const [buyModal, setBuyModal] = useState(false);
  const [sellModal, setSellModal] = useState(false);

  const [myBalanceListForFuture, setMyBalanceListForFuture] = useState([]);
  const [myBalanceListForFutureSpot, setMyBalanceListForFutureSpot] = useState(
    []
  );

  const [userBalanceList, setUserBalanceList] = useState([]);
  const [fiatCurrencyList, setFiatCurrencyList] = useState([]);
  const [usdbalance, setUsdbalance] = useState(null);
  const [sgdbalance, setSgdbalance] = useState(null);
  const [eurbalance, setEurbalance] = useState(null);
  const [aedbalance, setAedbalance] = useState(null);
  const [inrbalance, setInrbalance] = useState(null);
  const [gbpbalance, setGbpbalance] = useState(null);
  const [selectedCryptoCurrency, setSelectedCryptoCurrency] = useState(null);

  const [amount, setAmount] = useState(0);
  const [cryptoCurrency, setCryptoCurrency] = useState("");
  const [marginCurId, setMarginCurId] = useState(null);
  const [modalContent, setModalContent] = useState(null);

  const [flag, setFlag] = useState(false);
  const [responseMargin, setResponseMargin] = useState({});
  const [marginWalletBalance, setMarginWalletBalance] = useState(0);
  const [usedBalance, setUsedBalance] = useState(0);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [marginWalletId, setMarginWalletId] = useState(null);
  const [fiatCurrencyId, setFiatCurrencyId] = useState(null);

  const [fiatId, setFiatId] = useState(null);
  const [assetMarginFor, setAssetMarginFor] = useState("");

  const [fdata, setFdata] = useState([]);

  const [sendAmount, setSendAmount] = useState("");
  const [sendAmountFunding, setSendAmountFunding] = useState("");
  const [sendAmountMargin, setSendAmountMargin] = useState("");

  const [customerFundingModal, setCustomerFundingModal] = useState(false);
  const [marginSpotModal, setMarginSpotModal] = useState(false);

  const [fundingHomeViewIsoForFuture, setFundingHomeViewIsoForFuture] =
    useState([]);
  const [fundingHomeViewCrossForFuture, setFundingHomeViewCrossForFuture] =
    useState([]);
  const [fundingHomeViewFundingForFuture, setFundingHomeViewFundingForFuture] =
    useState([]);

  const [marginWalletBalance1, setMarginWalletBalance1] = useState(0);
  const [usedBalance1, setUsedBalance1] = useState(0);
  const [availableBalance1, setAvailableBalance1] = useState(0);
  const [marginwalletId1, setMarginwalletId1] = useState(null);
  const [currencyId1, setCurrencyId1] = useState(null);
  const [cryptoCurrency1, setCryptoCurrency1] = useState("");

  const [selectedContractTypeId, setSelectedContractTypeId] = useState("");
  const [
    portfolioBalanceForFuturePerpetual,
    setPortfolioBalanceForFuturePerpetual,
  ] = useState(null);
  const [
    portfolioBalanceForFutureCurrentQuarter,
    setPortfolioBalanceForFutureCurrentQuarter,
  ] = useState(null);
  const [
    portfolioBalanceForFutureNextQuarter,
    setPortfolioBalanceForFutureNextQuarter,
  ] = useState(null);

  const [portfolioHeadersForFuture, setPortfolioHeadersForFuture] = useState(
    []
  );
  const [
    portfolioValueForFutureContract1,
    setPortfolioValueForFutureContract1,
  ] = useState([]);
  const [
    portfolioValueForFutureContract2,
    setPortfolioValueForFutureContract2,
  ] = useState([]);
  const [
    portfolioValueForFutureContract3,
    setPortfolioValueForFutureContract3,
  ] = useState([]);
  const [fpgn, setFpgn] = useState([]);

  const [contractList, setContractList] = useState([]);
  const [contractName1, setContractName1] = useState("");
  const [contractName2, setContractName2] = useState("");
  const [contractName3, setContractName3] = useState("");
  const [contractName1Id, setContractName1Id] = useState(null);
  const [contractName2Id, setContractName2Id] = useState(null);
  const [contractName3Id, setContractName3Id] = useState(null);

  const [currencyName, setCurrencyName] = useState("");
  const [baseCurrencyName, setBaseCurrencyName] = useState("");
  const [assetCode, setAssetCode] = useState("");
  const [mpTransactionId, setMpTransactionId] = useState("");
  const [counterAssetPair, setCounterAssetPair] = useState("");
  const [counterLeverage, setCounterLeverage] = useState("");

  const [infoModal, setInfoModal] = useState(false);
  const [infoIndex, setInfoIndex] = useState(0);
  const [futureFiatHoldingStatus, setFutureFiatHoldingStatus] = useState(false);

  const handleCloseInfoModal = () => setInfoModal(false);

  const handleCustomerFundingModalClose = () => setCustomerFundingModal(false);

  const fiatLabels = ["SPOT WALLET", "MARGIN", "VIEW MY FUNDINGS"];
  const fiatValues = ["SPOT WALLET", "MARGIN", "VIEW MY FUNDINGS"];
  const assetLabels = ["SPOT WALLET", "MARGIN", "VIEW MY FUNDINGS"];
  const assetValues = ["SPOT WALLET", "MARGIN", "VIEW MY FUNDINGS"];

  const tabStyles = (isSelected) => ({
    color: "var(--text-color)",
    fontWeight: isSelected ? "bold" : "normal",
    fontSize: "16px",
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    minHeight: 0,
    padding: "6px 12px",
  });
  const contentStyle = {
    backgroundColor: theme === "dark" ? "#273338" : "#fff",
    boxShadow: "0 0 60px 30px #fff, 0 0 100px 60px #f0f, 0 0 140px 90px #0ff",
    color: theme === "dark" ? "white" : "black",
    textAlign: "center",
    border: "none",
    width: "400px",
    borderRadius: "8px",
    outline: "none",
  };

  const handleCloseMarginSpotModal = () => (
    setMarginSpotModal(false), setSendAmountMargin("")
  );
  const handleBuyClose = () => setBuyModal(false);
  const handleSellClose = () => setSellModal(false);

  const handleInfoModal = (index) => {
    setInfoIndex(index);
    setInfoModal(true);
  };

  const buttonStyles = (mode) => ({
    backgroundColor: btncolor,
    color: "var(--text-color)",
    borderRadius: "5px",
    padding: "5px 24px",
    textTransform: "none",
    border: selected === mode ? "none" : "1px solid #333",
    "&:hover": {
      backgroundColor: selected === mode ? btncolor : "#222",
    },
    width: "250px",
  });

  useEffect(() => {
    getMainWalletBalanceForFutureMargin();
    getUserTransaction();
    getAssetsForFutureMargin();
    getContractDetails();
  }, []);
  useEffect(() => {
    if (contractName1Id) {
      userPortfolioBalanceForFuture(selectedMarginType, contractName1Id);
      portfolioDetailsForFuture(selectedMarginType, contractName1Id);
    }
  }, [contractName1Id, contractName2Id, contractName3Id]);

  const handleCloseMarginModal = () => (
    setMarginModal(false), setSendAmount("")
  );
  const handleCloseFundingModal = () => (
    setFundingModal(false), setSendAmountFunding("")
  );
  const handleSelect = (mode) => {
    setSelected(mode);
    setValue(mode === "Isolated" ? 0 : 2);
    if (mode === "Isolated") {
      handleMarginTypeForFuturePortfolio(1);
    } else {
      handleMarginTypeForFuturePortfolio(2);
    }
  };

  const handleChangeCurrency = (event) => {
    setCurrency(event.target.value);

    setFiatCurrencyId(event.target.value);
    const filterdata = fundingHomeViewIsoForFuture?.filter(
      (d) => d?.CURRENCYID === event.target.value
    );
    setCurrencyName(filterdata[0]?.CURRENCY_NAME);
    somethingChangedForFuture(filterdata[0]?.CURRENCY_NAME);
  };
  const handleChangeAssetCurrency = (event) => {
    setAssetCurrency(event.target.value);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCurrency("");
    setMarginWalletBalance1(0);
    setUsedBalance1(0);
    setAvailableBalance1(0);
    setAssetCurrency("");
    setAssetFromDate(null);
    setAssetToDate(null);
    setSelected(newValue === 0 ? "Isolated" : "Cross");
    console.log("newValue", newValue);
    if (newValue === 0) {
      setSelectedMarginType(1);
    } else {
      setSelectedMarginType(2);
    }
  };
  const handleChangeFiatTab = (event, newValue) => {
    setFiatTab(newValue);
    setFromDate(null);
    setToDate(null);
    if (newValue === "SPOT WALLET") {
      getMainWalletBalanceForFutureMargin();
    }
    if (newValue === "MARGIN") {
      faitmarginForFuture();
    }
    // if(newValue === "VIEW MY FUNDINGS"){
    //   faitmarginForFuture()
    // }
  };
  useEffect(() => {
    faitmarginForFuture();
  }, [selectedMarginType, selectedLeverageType]);

  console.log("currencyName", currencyName);
  const handleChangeAssetTab = (event, newValue) => {
    setAssetTab(newValue);
    setCurrency("");
    setMarginWalletBalance1(0);
    setUsedBalance1(0);
    setAvailableBalance1(0);
    setAssetCurrency("");
    setAssetFromDate(null);
    setAssetToDate(null);
  };
  const handleChangePortfolioTab = (marginType, newValue) => {
    setPortfolioTab(newValue);
    if (newValue === contractName1) {
      userPortfolioBalanceForFuture(marginType, contractName1Id);
      portfolioDetailsForFuture(marginType, contractName1Id);
    }
    if (newValue === contractName2) {
      userPortfolioBalanceForFuture(marginType, contractName2Id);
      portfolioDetailsForFuture(marginType, contractName2Id);
    }
    if (newValue === contractName3) {
      userPortfolioBalanceForFuture(marginType, contractName3Id);
      portfolioDetailsForFuture(marginType, contractName3Id);
    }
  };

  const getMainWalletBalanceForFutureMargin = () => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    axios
      .get(`${FUTUREMARGINURL}getMainWalletBalance?uuid=${uuid}`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        const userBalance = response.data.userBalance;
        setMyBalanceListForFuture(userBalance);

        const spotBalance = userBalance.filter(
          (item) => item.currencyType === 1
        );
        setMyBalanceListForFutureSpot(spotBalance);

        console.log("myBalanceListForFutureSpot", spotBalance);
      })
      .catch((error) => {
        console.error("Error fetching wallet balance:", error);
      });
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const getSpecificCurrencyPrecision = (currencyName) => {
    // Replace with actual precision logic if needed
    if (currencyName === "USD") return 2;
    return 2;
  };

  const getUserTransaction = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };
    const jsonString = JSON.stringify(userTransObj);

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;

      if (result.error.error_data !== 0) {
        showToast("error", "Cannot fetch user balance");
        console.log("Fetching User balance failed");
      } else {
        setUserBalanceList(result.userBalanceList);

        const balenceList1 = result.userBalanceList || [];

        // Extract new fiat array
        const fiatArray = balenceList1
          .filter((item) => item.currencyType === 1)
          .map((item) => item.currencyCode);

        if (fiatArray.includes("USD")) {
          setFutureFiatHoldingStatus(true);
        } else {
          setFutureFiatHoldingStatus(false);
          selectedMarginType(2);
        }

        result.userBalanceList.forEach((balance) => {
          if (balance.currencyCode === "USD") {
            setUsdbalance(balance.closingBalance);
            localStorage.setItem("usdbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "SGD") {
            setSgdbalance(balance.closingBalance);
            localStorage.setItem("sgdbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "EUR") {
            setEurbalance(balance.closingBalance);
            localStorage.setItem("eurbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "AED") {
            setAedbalance(balance.closingBalance);
            localStorage.setItem("aedbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "INR") {
            setInrbalance(balance.closingBalance);
            localStorage.setItem("inrbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "GBP") {
            setGbpbalance(balance.closingBalance);
            localStorage.setItem("gbpbalance", balance.closingBalance);
          }
        });

        setSelectedCryptoCurrency(localStorage.getItem("selected_currency"));

        const fiatCurrencies = result.userBalanceList.filter(
          (balance) => balance.currencyType === "1"
        );
        const basecur = result.userBalanceList.filter(
          (x) => x.currencyCode == "USD"
        );

        setFiatCurrencyList(fiatCurrencies);
        // setFiatCurrencyId(basecur[0]?.currencyId);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
      } else {
        // showToast("error", error?.response?.data?.error?.error_msg);
      }
    }
  };

  const checkUserBlockStatus = async () => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/userAccountStatus`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      console.log("response kk", response);

      if (response.data.error?.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
        return false;
      }

      if (response.data.status !== 1) {
        //logout
        showToast("error", "Your user has been blocked by Admin");
        return false;
      }

      return true;
    } catch (error) {
      console.log("Error in checkUserBlockStatus:", error);
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === "401")
      ) {
        //logout
      }
      return false;
    }
  };

  const handleIsoFiatSpotClick = (
    modalType,
    currentBalance,
    currency,
    currencyId = ""
  ) => {
    setFiatCurrencyId(currencyId);
    setAmount(currentBalance);
    setCryptoCurrency(currency);
    // setMarginCurId(curId);
    if (modalType === "margin") {
      setMarginModal(true);
    } else {
      setFundingModal(true);
    }
    checkUserBlockStatus();
  };

  const faitmarginForFuture = async () => {
    setFlag(true);

    try {
      const uuid = localStorage.getItem("uuid");
      const token = localStorage.getItem("access_token");
      const url = `${FUTUREMARGINURL}getMarginWalletByCurrency?uuid=${uuid}&currencyName=${"USD"}&marginType=${selectedMarginType}&leverage=${selectedLeverageType}`;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${token}`,
        },
      });

      setResponseMargin(response.data);

      if (response.data.error !== 1) {
        setMarginWalletBalance(
          response.data.marginWalletBalance.toFixed(
            getSpecificCurrencyPrecision("USD")
          )
        );
        setUsedBalance(response.data.usedBalance);
        setAvailableBalance(
          response.data.availableBalance.toFixed(
            getSpecificCurrencyPrecision("USD")
          )
        );
        setMarginWalletId(response.data.marginWalletId);
        // Optionally alert success if needed:
        // data.alert("Balance is available", 'success');
      } else {
        setMarginWalletBalance(0);
        setUsedBalance(0);
        setAvailableBalance(0);
        showToast("error", "No Balance is Available Here");
      }

      getUserTransaction();
    } catch (error) {
      console.error("Error fetching margin wallet data:", error);
      showToast("error", "Failed to fetch data");
    }
  };

  const handleIsoFiatMarginSpot = (crypto, bal, curId, marginwltid, from) => {
    // spot modal open

    // setShow(true);
    setCryptoCurrency(crypto);
    setCurrencyName(crypto);
    setAmount(bal);
    setFiatId(curId);
    setFiatCurrencyId(curId);
    setMarginWalletId(marginwltid);
    setAssetMarginFor(from);
    setMarginSpotModal(true);
  };

  const reset = () => {
    setToDate(null);
    setFromDate(null);
  };

  const handleIsoFiatFundSubmit = (type) => {
    checkUserBlockStatus();
    // modal open

    console.log("type", type);

    if (type === 1) {
      assetFundingMargin(fromData, toData, 1);
    } else {
      if (assetCurrency === "") {
        showToast("error", "Please Fill-up all field");
        return;
      }
      assetFundingMargin(assetFromData, assetToData, assetCurrency);
    }
  };

  const formatDate = (value) => dayjs(value).format("DD-MM-YYYY");

  const getSpecificCurrencyPrecisionFund = (currency) => {
    // Replace with actual precision logic
    const precisionMap = {
      USD: 2,
      BCH: 8,
      // add more as needed
    };
    return precisionMap[currency] || 6;
  };

  const assetFundingMargin = (fDate, tDate, currencyId) => {
    console.log("fromData", fDate, tDate);
    if (fDate === null && tDate === null) {
      showToast("error", "Please Fill-up from date and to date both");
      return;
    }
    if (fDate > tDate) {
      showToast("error", "To Date Must be greater than from date!!");
      return;
    }
    const objdatafund = {
      uuid: localStorage.getItem("uuid"),
      currencyId: currencyId,
      fromDate: formatDate(fDate),
      toDate: formatDate(tDate),
    };

    axios
      .post(
        `${FUTUREMARGINURL}fundingViewByInputValue`,
        JSON.stringify(objdatafund),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        const list = response.data.fundingHomeResponseDtoList;
        reset();
        const arr = list.map((item) => {
          const currency = item.currencyName;
          const amount =
            currency === "US Dollar"
              ? parseFloat(item.amount).toFixed(
                  getSpecificCurrencyPrecisionFund("USD")
                )
              : currency === "BCC"
              ? parseFloat(item.amount).toFixed(
                  getSpecificCurrencyPrecisionFund("BCH")
                )
              : parseFloat(item.amount).toFixed(
                  getSpecificCurrencyPrecisionFund(currency)
                );

          return {
            currencyName: currency,
            lendingDate: item.lendingDate,
            returnDate: item.returnDate,
            amount,
          };
        });
        setFdata(arr);
        setCustomerFundingModal(true);
        setToDate(null);
        setFromDate(null);
        setAssetToDate(null);
        setAssetFromDate(null);
        console.log(arr);
      })
      .catch((error) => {
        console.error("Error fetching funding data:", error);
      });
  };

  const assetlendingPrice = async () => {
    // const objdata = {
    //   customerId: Number(localStorage.getItem("userId")),
    //   amount: sendAmount,
    //   currencyId: fiatCurrencyId,
    //   baseCurrencyId: fiatCurrencyId,
    //   unitPrice: "0",
    //   marginType: selectedMarginType,
    // };
    const objdata = {
      uuid: localStorage.getItem("uuid"),
      amount: sendAmount,
      currencyId: fiatCurrencyId,
      baseCurrencyId: fiatCurrencyId,
      unitPrice: "0",
      marginType: selectedMarginType,
      assetPair: cryptoCurrency,
    };

    try {
      const response = await axios.post(
        `${FUTUREMARGINURL}transferBalanceToMWB`,
        JSON.stringify(objdata),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const data = response.data;

      if (data.error === 1) {
        showToast("error", "Margin is not successfully. Please try again");
      } else {
        showToast("success", "Margin successful");
        getUserTransaction();
        getMainWalletBalanceForFutureMargin();
        handleCloseMarginModal();
      }
    } catch (error) {
      showToast("error", "Something went wrong. Please try again later.");
      console.error("assetlendingPrice error:", error);
    }
  };

  const assetfundBuy = async () => {
    const objdata = {
      uuid: localStorage.getItem("uuid"),
      amount: Number(sendAmountFunding),
      currencyId: fiatCurrencyId,
      baseCurrencyId: fiatCurrencyId,
      unitPrice: 50,
      returnDate: formatDate(returnDate),
      assetPair: cryptoCurrency?.toUpperCase(),
    };

    try {
      const response = await axios.post(
        `${FUTUREMARGINURL}transferFund`,
        JSON.stringify(objdata),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.returnId !== 1) {
        showToast("error", result?.message);
      } else {
        showToast("success", "Funding successful");
        getUserTransaction();
        getMainWalletBalanceForFutureMargin();
        handleCloseFundingModal();
      }
    } catch (error) {
      console.error("Funding request failed:", error);
      showToast("error", "Funding is not successfully. Please try again");
    }
  };
  console.log("fiatCurrencyId", fiatCurrencyId);

  const fiatholdingPrice = () => {
    const cryptomargintowalletObj = {
      uuid: localStorage.getItem("uuid"),
      marginWalletId: marginWalletId,
      amount: Number(sendAmountMargin),
      currencyId: fiatCurrencyId,
      marginType: selectedMarginType,
    };

    const jsonString = JSON.stringify(cryptomargintowalletObj);

    let url = `${FUTUREMARGINURL}transferBalanceMarginToMainWallet`;

    axios
      .post(url, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const result = response.data;
        if (result.error !== 0) {
          showToast("error", result.message);
        } else {
          showToast("success", result.message);
          getUserTransaction();
          getMainWalletBalanceForFutureMargin();
          // faitmarginForFuture();
          somethingChangedForFuture(currencyName);
          setFiatTab("SPOT WALLET");
          getMainWalletBalanceForFutureMargin();
          handleCloseMarginSpotModal();
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        showToast("error", "An error occurred. Please try again.");
      });
  };

  const getAssetsForFutureMargin = () => {
    axios
      .get(`${FUTUREMARGINURL}fundingHomeView`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const currenciesIso = response.data.P_ISO_MARGIN_CURRENCY || [];
        const currenciesCross = response.data.P_CROSS_MARGIN_CURRENCY || [];
        const currenciesFunding = response.data.P_FUNDING_CURRENCY || [];

        const arrIso = currenciesIso.filter((item) => item.CURRENCY_TYPE !== 1);
        const arrCross = currenciesCross.filter(
          (item) => item.CURRENCY_TYPE !== 1
        );
        const arrFunding = currenciesFunding.filter(
          (item) => item.CURRENCY_TYPE !== 1
        );

        setFundingHomeViewIsoForFuture(arrIso);
        setFundingHomeViewCrossForFuture(arrCross);
        setFundingHomeViewFundingForFuture(arrFunding);
      })
      .catch((error) => {
        console.error("Error fetching future margin assets:", error);
      });
  };

  const somethingChangedForFuture = async (event) => {
    const bal = event;
    setFlag(true);

    try {
      const response = await axios.get(
        `${FUTUREMARGINURL}getMarginWalletByCurrency`,
        {
          params: {
            uuid: localStorage.getItem("uuid"),
            currencyName: bal,
            marginType: selectedMarginType,
            leverage: selectedLeverageType,
          },
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const responsemargin = response.data;

      if (responsemargin.error !== 1) {
        const precision = getSpecificCurrencyPrecision(bal);
        setMarginWalletBalance1(
          responsemargin.marginWalletBalance.toFixed(precision)
        );
        setUsedBalance1(responsemargin.usedBalance);
        setAvailableBalance1(
          responsemargin.availableBalance.toFixed(precision)
        );
        setMarginwalletId1(responsemargin.marginWalletId);
        setCurrencyId1(responsemargin.currencyId);
        setCryptoCurrency1(responsemargin.currencyName);
        // Optionally notify: data.alert("Balance is available", 'success');
      } else {
        setMarginWalletBalance1(0);
        setUsedBalance1(0);
        setAvailableBalance1(0);
        showToast("error", `No Balance Available for ${bal}`);
      }

      getUserTransaction();
    } catch (error) {
      console.error("Error fetching margin wallet data", error);
      showToast("error", "An error occurred while fetching balance.");
    }
  };

  const getContractDetails = () => {
    axios
      .get(`${WEBSERVICE}fTrade/getContractsName`, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const result = response.data;
        if (result.statusCode === 0) {
          const contract = result.contractList;
          setContractList(contract);

          setContractName1(contract[0]?.contractName || "");
          setPortfolioTab(contract[0]?.contractName || "");
          setContractName1Id(contract[0]?.contractTypeId || null);

          setContractName2(contract[1]?.contractName || "");
          setContractName2Id(contract[1]?.contractTypeId || null);

          setContractName3(contract[2]?.contractName || "");
          setContractName3Id(contract[2]?.contractTypeId || null);

          setSelectedContractTypeId(contract[0]?.contractTypeId || null);
        } else {
          showToast("error", result.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching contract details:", error);
        showToast("error", "Something went wrong while fetching contracts.");
      });
  };

  const userPortfolioBalanceForFuture = (marginType, contractTypeId) => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");
    const url = `${FUTUREMARGINURL}userPortfolioBalance?uuid=${uuid}&marginType=${marginType}&contractTypeId=${contractTypeId}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        const data = response.data;
        if (contractTypeId === contractName1Id) {
          setPortfolioBalanceForFuturePerpetual(data.userBalance);
        } else if (contractTypeId === contractName2Id) {
          setPortfolioBalanceForFuturePerpetual(data.userBalance);
        } else if (contractTypeId === contractName3Id) {
          setPortfolioBalanceForFuturePerpetual(data.userBalance);
        } else {
          // If no match, you can optionally clear or log
          setPortfolioBalanceForFuturePerpetual([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio balance:", error);
      });
  };

  const portfolioDetailsForFuture = (marginType, contractTypeId) => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");
    const url = `${FUTUREMARGINURL}portfolioDetails?uuid=${uuid}&marginType=${marginType}&contractTypeId=${contractTypeId}`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      })
      .then((response) => {
        const { header, values } = response.data;
        setPortfolioHeadersForFuture(header);

        let arrPerp = [];
        let arrCurrent = [];
        let arrNext = [];

        if (values && values.length !== 0) {
          values.forEach((item) => {
            if (item.contractTypeId === contractName1Id) arrPerp.push(item);
            if (item.contractTypeId === contractName2Id) arrCurrent.push(item);
            if (item.contractTypeId === contractName3Id) arrNext.push(item);
          });

          const pages = [];
          // for (let i = 1; i <= Math.ceil(ftotalCount / 20); i++) {
          //   pages.push(i);
          // }
          setFpgn(pages);
        } else {
          arrPerp = [];
          arrCurrent = [];
          arrNext = [];
        }

        if (contractTypeId === contractName1Id) {
          setPortfolioValueForFutureContract1(arrPerp);
        } else if (contractTypeId === contractName2Id) {
          setPortfolioValueForFutureContract1(arrCurrent);
        } else if (contractTypeId === contractName3Id) {
          setPortfolioValueForFutureContract1(arrNext);
        } else {
          // If no match, you can optionally clear or log
          setPortfolioValueForFutureContract1([]);
          console.warn("Unknown contractTypeId:", contractTypeId);
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio details:", error);
      });
  };

  const handleMarginTypeForFuturePortfolio = (param) => {
    setSelectedMarginType(param);
    handleChangePortfolioTab(param, portfolioTab);
  };

  const modalbuyForFuture = (
    amount,
    curName,
    base_currency,
    assetCode,
    mpportfolioid,
    assetpair,
    leverage,
    type
  ) => {
    setAmount(amount);
    setCurrencyName(curName);
    setBaseCurrencyName(base_currency);
    setAssetCode(assetCode);
    setMpTransactionId(mpportfolioid);
    setCounterAssetPair(assetpair);
    setCounterLeverage(leverage);
    if (type === "buy") {
      setBuyModal(true);
    } else {
      setSellModal(true);
    }
  };

  const portfolioholdingBuyForFuture = async () => {
    const onlyBuyAmount = amount;

    try {
      const priceResponse = await axios.get(
        `https://futures-stream.paybito.com/fSocketStream/api/marketPrice`,
        {
          params: {
            symbol: counterAssetPair,
            side: "BID",
            amount: onlyBuyAmount,
            marginType: selectedMarginType,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = priceResponse.data;
      if (result.statuscode !== 0) {
        const price1 = parseFloat(result.price1);

        const inputObj = {
          selling_asset_code: baseCurrencyName.toUpperCase(),
          buying_asset_code: currencyName.toUpperCase(),
          amount: parseFloat(onlyBuyAmount),
          price: price1,
          offerType: "P",
          txn_type: "1",
          assetCode: assetCode,
          portfolioId: mpTransactionId,
          marginType: selectedMarginType,
          assetPair: counterAssetPair,
          leverage: counterLeverage,
          uuid: localStorage.getItem("uuid"),
        };

        if (price1 * onlyBuyAmount >= 0.001) {
          const tradeResponse = await axios.post(
            `${WEBSERVICE}fTrade/TradeCreateOffer`,
            JSON.stringify(inputObj),
            {
              headers: {
                "Content-Type": "application/json",
                authorization: "BEARER " + localStorage.getItem("access_token"),
              },
            }
          );

          const tradeResult = tradeResponse.data;

          if (tradeResult.error.error_data !== 0) {
            showToast("error", tradeResult.error.error_msg);
          } else {
            showToast("success", tradeResult.error.error_msg);
            handleBuyClose();
            setAssetTab("SPOT WALLET");
            if (portfolioTab === contractName1) {
              userPortfolioBalanceForFuture(
                selectedMarginType,
                contractName1Id
              );
              portfolioDetailsForFuture(selectedMarginType, contractName1Id);
            }
            if (portfolioTab === contractName2) {
              userPortfolioBalanceForFuture(
                selectedMarginType,
                contractName2Id
              );
              portfolioDetailsForFuture(selectedMarginType, contractName2Id);
            }
            if (portfolioTab === contractName3) {
              userPortfolioBalanceForFuture(
                selectedMarginType,
                contractName3Id
              );
              portfolioDetailsForFuture(selectedMarginType, contractName3Id);
            }
          }
        } else {
          showToast("error", "Offer Value is lesser than permissible value");
        }
      } else {
        showToast("error", result.message);
      }
      handleBuyClose();
    } catch (error) {
      showToast("error", "Something went wrong. Please try again later.");
    }
  };

  const validateNumber = (e) => {
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "Tab" ||
      e.key === "Escape" ||
      e.key === "Enter" ||
      e.key.startsWith("Arrow")
    ) {
      return;
    }
    if (e.key === "." && !e.currentTarget.value.includes(".")) {
      return;
    }
    // Block anything that's not a digit
    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const portfolioholdingSellForFuture = () => {
    const onlySellAmount = amount;

    axios
      .get(`https://futures-stream.paybito.com/fSocketStream/api/marketPrice`, {
        params: {
          symbol: counterAssetPair,
          side: "ASK",
          amount: onlySellAmount,
          marginType: selectedMarginType,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const result = response.data;

        if (result.statuscode !== 0) {
          const parsedPrice1 = parseFloat(result.price1);
          const inputObj = {
            selling_asset_code: currencyName.toUpperCase(),
            buying_asset_code: baseCurrencyName.toUpperCase(),
            amount: parseFloat(onlySellAmount),
            price: parsedPrice1,
            offerType: "P",
            txn_type: "2",
            assetCode: assetCode,
            portfolioId: mpTransactionId,
            marginType: selectedMarginType,
            assetPair: counterAssetPair,
            leverage: counterLeverage,
            uuid: localStorage.getItem("uuid"),
          };

          if (parsedPrice1 * onlySellAmount >= 0.001) {
            axios
              .post(
                `${WEBSERVICE}fTrade/TradeCreateOffer`,
                JSON.stringify(inputObj),
                {
                  headers: {
                    "Content-Type": "application/json",
                    authorization:
                      "BEARER " + localStorage.getItem("access_token"),
                  },
                }
              )
              .then((res) => {
                const tradeResult = res.data;

                if (tradeResult.error.error_data !== 0) {
                  showToast("error", tradeResult.error.error_msg);
                } else {
                  showToast("success", tradeResult.error.error_msg);
                  handleSellClose();
                  setAssetTab("SPOT WALLET");
                  if (portfolioTab === contractName1) {
                    userPortfolioBalanceForFuture(
                      selectedMarginType,
                      contractName1Id
                    );
                    portfolioDetailsForFuture(
                      selectedMarginType,
                      contractName1Id
                    );
                  }
                  if (portfolioTab === contractName2) {
                    userPortfolioBalanceForFuture(
                      selectedMarginType,
                      contractName2Id
                    );
                    portfolioDetailsForFuture(
                      selectedMarginType,
                      contractName2Id
                    );
                  }
                  if (portfolioTab === contractName3) {
                    userPortfolioBalanceForFuture(
                      selectedMarginType,
                      contractName3Id
                    );
                    portfolioDetailsForFuture(
                      selectedMarginType,
                      contractName3Id
                    );
                  }
                }
              });
          } else {
            showToast("error", "Offer Value is lesser than permissible value");
          }
        } else {
          showToast("error", result.message);
        }
        handleSellClose();
      })
      .catch((error) => {
        showToast("error", "Something went wrong. Please try again later.");
      });
  };

  return (
    <Box sx={pageWrapper}>
      {/* ── Hero Banner ── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(
            btncolor || "#1976d2",
            0.95
          )} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <TimelineOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box>
            <Typography sx={heroTitle}>Futures Wallet</Typography>
            <Typography sx={heroSubtitle}>
              Manage your futures margin, funding and portfolio positions
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Margin Mode ── */}
      <Box sx={{ ...mainCard, mb: 3 }}>
        <Box
          sx={{
            px: 2,
            py: 1.5,
            borderBottom: "1px solid rgba(125,125,125,0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: btncolor,
                height: 3,
                borderRadius: "3px 3px 0 0",
              },
            }}
            sx={{
              minHeight: 48,
              "& .MuiTab-root": {
                minHeight: 48,
                textTransform: "uppercase",
                fontWeight: 700,
                fontSize: "0.9rem",
                letterSpacing: "0.04em",
                color: "var(--text-color)",
                opacity: 0.65,
                "&.Mui-selected": { opacity: 1, color: "var(--text-color)" },
              },
            }}
          >
            <Tab
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  ISOLATED
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => handleInfoModal(0)}
                  >
                    <InfoIcon style={{ fontSize: "15px" }} />
                  </span>
                </Box>
              }
            />
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                mt: 1.5,
                borderColor: "rgba(125,125,125,0.3)",
                height: 24,
                borderRightWidth: 2,
                alignSelf: "center",
              }}
            />
            <Tab
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  CROSS
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => handleInfoModal(1)}
                  >
                    <InfoIcon style={{ fontSize: "15px" }} />
                  </span>
                </Box>
              }
            />
          </Tabs>
        </Box>
      </Box>

      <Grid container spacing={2}>
        {futureFiatHoldingStatus ? (
          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <Box sx={sectionCard}>
              <Box sx={sectionHeader}>
                <Typography sx={cardSectionTitle}>
                  Fiat Holdings{" "}
                  <span
                    style={{ cursor: "pointer", marginLeft: "10px" }}
                    onClick={() => handleInfoModal(2)}
                  >
                    <InfoIcon style={{ fontSize: "15px" }} />
                  </span>
                </Typography>
              </Box>

              <Box sx={{ width: "100%" }}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {fiatLabels.map((label, index) => (
                    <Button
                      key={label}
                      onClick={() =>
                        handleChangeFiatTab(null, fiatValues[index])
                      }
                      sx={{
                        flex: 1,
                        mx: 1,
                        color:
                          fiatTab === fiatValues[index]
                            ? "var(--text-color)"
                            : "gray",
                        fontSize: "14px",
                        fontWeight: "bold",
                        textTransform: "none",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                      }}
                    >
                      {label}
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleInfoModal(3 + index);
                        }}
                      >
                        {/* <i className="fa fa-info-circle" aria-hidden="true"></i> */}
                        <InfoIcon style={{ fontSize: "15px" }} />
                      </span>
                    </Button>
                  ))}
                </Box>
              </Box>

              <TableContainer
                className="wallet_table future_wallet"
                sx={{ px: 2 }}
              >
                {fiatTab === "SPOT WALLET" && (
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow sx={modernTableHeadRow}>
                        {FiatSpotColumn.map((column, i) => (
                          <TableCell key={i} sx={modernTableHeadCell}>
                            {column}
                            {i === 2 && (
                              <span
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "10px",
                                }}
                                onClick={() => handleInfoModal(7)}
                              >
                                {/* <i
                                  class="fa fa-info-circle"
                                  aria-hidden="true"
                                ></i> */}
                                <InfoIcon style={{ fontSize: "15px" }} />
                              </span>
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {myBalanceListForFutureSpot?.length !== 0 ? (
                        myBalanceListForFutureSpot?.map((b, i) => (
                          <TableRow sx={modernTableBodyRow}>
                            <TableCell sx={modernTableBodyCell}>
                              {b?.currency}
                            </TableCell>
                            <TableCell sx={modernTableBodyCell}>
                              {" "}
                              {b?.currentBalance}
                            </TableCell>
                            <TableCell sx={modernTableBodyCell}>
                              {b?.isFuturesIsoMargin === 1 && (
                                <>
                                  <ContainedButton
                                    variant="contained"
                                    size="small"
                                    onClick={() =>
                                      handleIsoFiatSpotClick(
                                        "margin",
                                        b.currentBalance,
                                        b.currency,
                                        b.currencyId
                                      )
                                    }
                                  >
                                    Margin
                                  </ContainedButton>
                                  <span
                                    style={{ cursor: "pointer", margin: "5px" }}
                                    onClick={() => handleInfoModal(8)}
                                  >
                                    {/* <i
                                      class="fa fa-info-circle"
                                      aria-hidden="true"
                                    ></i> */}
                                    <InfoIcon style={{ fontSize: "15px" }} />
                                  </span>
                                  <ContainedButton
                                    variant="contained"
                                    size="small"
                                    onClick={() =>
                                      handleIsoFiatSpotClick(
                                        "funding",
                                        b.currentBalance,
                                        b.currency,
                                        b.currencyId
                                      )
                                    }
                                  >
                                    Funding
                                  </ContainedButton>
                                  <span
                                    style={{ cursor: "pointer", margin: "5px" }}
                                    onClick={() => handleInfoModal(9)}
                                  >
                                    {/* <i
                                      class="fa fa-info-circle"
                                      aria-hidden="true"
                                    ></i> */}
                                    <InfoIcon style={{ fontSize: "15px" }} />
                                  </span>
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={3}
                            className="text-center"
                            sx={modernTableBodyCell}
                          >
                            No Data
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                )}
                {fiatTab === "MARGIN" && (
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow sx={modernTableHeadRow}>
                        {FiatMarginColumn.map((column, i) => (
                          <TableCell key={i} sx={modernTableHeadCell}>
                            {column}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={modernTableBodyRow}>
                        <TableCell sx={modernTableBodyCell}>USD</TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {" "}
                          {marginWalletBalance}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {" "}
                          {usedBalance}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          {" "}
                          {availableBalance}
                        </TableCell>
                        <TableCell sx={modernTableBodyCell}>
                          <ContainedButton
                            variant="contained"
                            size="small"
                            onClick={() =>
                              handleIsoFiatMarginSpot(
                                "USD",
                                marginWalletBalance,
                                1,
                                marginWalletId,
                                "futures"
                              )
                            }
                          >
                            Spot
                          </ContainedButton>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}
                {fiatTab === "VIEW MY FUNDINGS" && (
                  <Box>
                    <Grid
                      container
                      spacing={2}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Grid size={{ xs: 4, sm: 12, md: 3 }}>
                        <p>From Date</p>
                      </Grid>
                      <Grid size={{ xs: 8, sm: 12, md: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            format="DD-MM-YYYY"
                            value={fromData}
                            onChange={(newValue) => setFromDate(newValue)}
                            slots={{
                              openPickerIcon: CalendarMonthIcon,
                            }}
                            slotProps={{
                              textField: {
                                placeholder: "dd-mm-yyyy",
                                fullWidth: true,
                                sx: {
                                  backgroundColor: "var(--body-color-less)",

                                  borderRadius: 1,
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12, md: 3 }} />
                      <Grid size={{ xs: 4, sm: 12, md: 3 }}>
                        <p>To Date &nbsp; &nbsp;</p>
                      </Grid>
                      <Grid size={{ xs: 8, sm: 12, md: 6 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            format="DD-MM-YYYY"
                            value={toData}
                            onChange={(newValue) => setToDate(newValue)}
                            slots={{
                              openPickerIcon: CalendarMonthIcon,
                            }}
                            slotProps={{
                              textField: {
                                placeholder: "dd-mm-yyyy",
                                fullWidth: true,
                                sx: {
                                  backgroundColor: "var(--body-color-less)",

                                  borderRadius: 1,
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12, md: 3 }} />
                      <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                        <ContainedButton
                          variant="contained"
                          onClick={() => handleIsoFiatFundSubmit(1)}
                        >
                          Submit
                        </ContainedButton>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </TableContainer>
            </Box>
          </Grid>
        ) : (
          <Grid size={2} />
        )}

        <Grid size={{ xs: 12, sm: 12, md: futureFiatHoldingStatus ? 6 : 12 }}>
          <Box sx={sectionCard}>
            <Box sx={sectionHeader}>
              <Typography sx={cardSectionTitle}>
                Crypto Holdings{" "}
                <span
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  onClick={() => handleInfoModal(6)}
                >
                  <InfoIcon style={{ fontSize: "15px" }} />
                </span>
              </Typography>
            </Box>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {assetLabels.map((label, index) => (
                  <Button
                    key={label}
                    onClick={() =>
                      handleChangeAssetTab(null, assetValues[index])
                    }
                    sx={{
                      flex: 1,
                      mx: 1,
                      color:
                        assetTab === assetValues[index]
                          ? "var(--btn-color)"
                          : "var(--text-color)",
                      fontSize: "14px",
                      fontWeight: "bold",
                      textTransform: "none",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                    }}
                  >
                    {label}
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents button click
                        handleInfoModal(13 + index);
                      }}
                    >
                      {/* <i className="fa fa-info-circle" aria-hidden="true"></i> */}
                      <InfoIcon style={{ fontSize: "15px" }} />
                    </span>
                  </Button>
                ))}
              </Box>
            </Box>

            <TableContainer
              className="wallet_table future_wallet"
              sx={{ px: 2 }}
            >
              {assetTab === "SPOT WALLET" && (
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow sx={modernTableHeadRow}>
                      {AssetSpotColumn.map((column, i) => (
                        <TableCell key={i} sx={modernTableHeadCell}>
                          {column}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {myBalanceListForFuture?.length !== 0 ? (
                      myBalanceListForFuture?.map((b, i) => {
                        if (b.currencyType !== 2) return null;
                        return (
                          <TableRow key={i} sx={modernTableBodyRow}>
                            <TableCell sx={modernTableBodyCell}>
                              {b?.currency}
                            </TableCell>
                            <TableCell sx={modernTableBodyCell}>
                              {" "}
                              {b?.currentBalance}
                            </TableCell>
                            <TableCell
                              className="d-flex justify-content-end align-items-center"
                              sx={modernTableBodyCell}
                            >
                              {b?.isFuturesCrossMargin === 1 && (
                                <>
                                  {" "}
                                  <a
                                    href="#"
                                    style={{
                                      color: "var(--text-color)",
                                    }}
                                    onClick={() =>
                                      handleIsoFiatSpotClick(
                                        "margin",
                                        b.currentBalance,
                                        b.currency,
                                        b.currencyId
                                      )
                                    }
                                  >
                                    MARGIN
                                  </a>
                                  <span
                                    style={{ cursor: "pointer", margin: "5px" }}
                                    onClick={() => handleInfoModal(10)}
                                  >
                                    {/* <i
                                      class="fa fa-info-circle"
                                      aria-hidden="true"
                                    ></i> */}
                                    <InfoIcon style={{ fontSize: "15px" }} />
                                  </span>
                                </>
                              )}
                              <a
                                href="#"
                                style={{
                                  color: "var(--text-color)",
                                }}
                                onClick={() =>
                                  handleIsoFiatSpotClick(
                                    "funding",
                                    b.currentBalance,
                                    b.currency,
                                    b.currencyId
                                  )
                                }
                              >
                                FUNDING
                              </a>
                              <span
                                style={{ cursor: "pointer", margin: "5px" }}
                                onClick={() => handleInfoModal(11)}
                              >
                                {/* <i
                                  class="fa fa-info-circle"
                                  aria-hidden="true"
                                ></i> */}
                                <InfoIcon style={{ fontSize: "15px" }} />
                              </span>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          className="text-start"
                          sx={modernTableBodyCell}
                        >
                          No Data Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              )}
              {assetTab === "MARGIN" && (
                <Box sx={{ px: 2 }}>
                  <Grid
                    container
                    spacing={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Grid size={3} sx={{ textAlign: "start" }}>
                      Asset :
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                      <FormControl
                        fullWidth
                        sx={{
                          backgroundColor: "var(--body-color-less)",
                          mt: 2,
                        }}
                      >
                        <InputLabel
                          id="currency-select-label"
                          sx={{
                            color: "var(--text-color)",
                            // "&.Mui-focused": {
                            //   color: theme === "dark" ? "#fff" : "#000",
                            // },
                          }}
                        >
                          Select Currency
                        </InputLabel>
                        <Select
                          labelId="currency-select-label"
                          id="currency-select"
                          value={currency}
                          label="Select Currency"
                          onChange={handleChangeCurrency}
                          sx={{
                            color: "var(--text-color)",
                            textAlign: "start",
                            // backgroundColor: "#1e1f24",
                            borderRadius: 1,
                            // ".MuiOutlinedInput-notchedOutline": {
                            //   borderColor: "#2c2d33",
                            // },
                            // "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            //   borderColor: "#555",
                            // },
                            // "&:hover .MuiOutlinedInput-notchedOutline": {
                            //   borderColor: "#555",
                            // },
                            // ".MuiSvgIcon-root ": {
                            //   fill: "#fff !important",
                            // },
                          }}
                        >
                          {fundingHomeViewIsoForFuture?.map((d, i) =>
                            d?.CURRENCYNAME !== "BCC" ? (
                              <MenuItem value={d?.CURRENCYID} key={i}>
                                {d?.CURRENCY_NAME}
                              </MenuItem>
                            ) : (
                              <MenuItem value={"BCH"} key={i}>
                                {"BCH"}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid size={3} />
                    <Grid size={12} sx={{ textAlign: "start" }}>
                      <p className="pb-2">
                        Margin Wallet Balance:{" "}
                        <span className="text-success">
                          {marginWalletBalance1}
                        </span>
                      </p>
                      <p className="pb-2">
                        Used Balance:
                        <span className="text-success"> {usedBalance1}</span>
                      </p>
                      <p className="pb-2 ">
                        Available Balance:{" "}
                        <span className="text-success">
                          {availableBalance1}
                        </span>
                      </p>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <p>Transfer To :</p>
                        <ContainedButton
                          variant="contained"
                          sx={{ mx: 1 }}
                          size="small"
                          onClick={() =>
                            handleIsoFiatMarginSpot(
                              cryptoCurrency1,
                              marginWalletBalance1,
                              currencyId1,
                              marginwalletId1,
                              "futures"
                            )
                          }
                        >
                          Spot
                        </ContainedButton>
                        <span
                          style={{
                            cursor: "pointer",
                            margin: "5px",
                            color: "gray",
                          }}
                          onClick={() => handleInfoModal(7)}
                        >
                          {/* <i class="fa fa-info-circle" aria-hidden="true"></i> */}
                          <InfoIcon style={{ fontSize: "15px" }} />
                        </span>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {assetTab === "VIEW MY FUNDINGS" && (
                <Box sx={{ px: 2 }}>
                  <Grid
                    container
                    spacing={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Grid size={3} sx={{ textAlign: "start" }}>
                      Asset Provided:
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                      <FormControl
                        fullWidth
                        sx={{
                          backgroundColor: "var(--body-color-less)",
                          mt: 2,
                        }}
                      >
                        <InputLabel
                          id="currency-select-label"
                          sx={{
                            color: "var(--text-color)",
                            // "&.Mui-focused": {
                            //   color: theme === "dark" ? "#fff" : "#000",
                            // },
                          }}
                        >
                          Select Currency
                        </InputLabel>
                        <Select
                          labelId="currency-select-label"
                          id="currency-select"
                          value={assetCurrency}
                          label="Select Currency"
                          onChange={handleChangeAssetCurrency}
                          sx={{
                            color: "var(--text-color)",
                            textAlign: "start",
                            // backgroundColor: "#1e1f24",
                            borderRadius: 1,
                            // ".MuiOutlinedInput-notchedOutline": {
                            //   borderColor: "#2c2d33",
                            // },
                            // "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            //   borderColor: "#555",
                            // },
                            // "&:hover .MuiOutlinedInput-notchedOutline": {
                            //   borderColor: "#555",
                            // },
                            // ".MuiSvgIcon-root ": {
                            //   fill: "#fff !important",
                            // },
                          }}
                        >
                          {fundingHomeViewFundingForFuture?.map((d, i) =>
                            d?.CURRENCYNAME !== "BCC" ? (
                              <MenuItem value={d?.CURRENCYID} key={i}>
                                {d?.CURRENCY_NAME}
                              </MenuItem>
                            ) : (
                              <MenuItem value={"BCH"} key={i}>
                                {"BCH"}
                              </MenuItem>
                            )
                          )}{" "}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid size={3} />
                    <Grid size={3}>
                      <p className=" text-start">From Date</p>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          format="DD-MM-YYYY"
                          value={assetFromData}
                          onChange={(newValue) => setAssetFromDate(newValue)}
                          slots={{
                            openPickerIcon: CalendarMonthIcon,
                          }}
                          sx={{
                            backgroundColor: "var(--body-color-less)",
                          }}
                          slotProps={{
                            textField: {
                              placeholder: "dd-mm-yyyy",
                              fullWidth: true,
                              // sx: {
                              //   backgroundColor: "#0F111A",
                              //   input: { color: "#B0B3B8" }, // text color
                              //   svg: { color: "#B0B3B8" }, // icon color
                              //   borderRadius: 1,
                              // },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid size={3} />
                    <Grid size={3}>
                      <p className="text-start">To Date &nbsp; &nbsp;</p>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          format="DD-MM-YYYY"
                          value={assetToData}
                          onChange={(newValue) => setAssetToDate(newValue)}
                          slots={{
                            openPickerIcon: CalendarMonthIcon,
                          }}
                          sx={{
                            backgroundColor: "var(--body-color-less)",
                          }}
                          slotProps={{
                            textField: {
                              placeholder: "dd-mm-yyyy",
                              fullWidth: true,
                              // sx: {
                              //   backgroundColor: "#0F111A",
                              //   input: { color: "#B0B3B8" }, // text color
                              //   svg: { color: "#B0B3B8" }, // icon color
                              //   borderRadius: 1,
                              // },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid size={3} />
                    <Grid
                      size={3}
                      sx={{ display: "flex", justifyContent: "start" }}
                    >
                      <ContainedButton
                        variant="contained"
                        onClick={() => handleIsoFiatFundSubmit(2)}
                      >
                        Submit
                      </ContainedButton>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </TableContainer>
          </Box>
        </Grid>
      </Grid>

      {/* ── Portfolio ── */}
      <Box sx={{ ...mainCard, mt: 3 }}>
        <Box sx={sectionHeader}>
          <Typography sx={cardSectionTitle}>
            Portfolio{" "}
            <span
              style={{
                cursor: "pointer",
                marginLeft: "10px",
                fontSize: "20px",
              }}
              onClick={() => handleInfoModal(12)}
            >
              <InfoIcon style={{ fontSize: "15px" }} />
            </span>
          </Typography>
        </Box>
        {contractName1 && contractName2 && contractName3 && (
          <Tabs
            value={portfolioTab}
            onChange={(event, newValue) =>
              handleChangePortfolioTab(selectedMarginType, newValue)
            }
            textColor="inherit"
            TabIndicatorProps={{
              style: {
                backgroundColor: btncolor,
                height: 3,
                borderRadius: "3px 3px 0 0",
              },
            }}
            aria-label="custom tabs"
            sx={{
              width: "100%",
              borderBottom: "1px solid rgba(125,125,125,0.12)",
              "& .MuiTabs-flexContainer": {
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
              },
              "& .MuiTab-root": {
                flex: 1,
                fontWeight: 700,
                fontSize: "0.95rem",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
                color: "var(--text-color)",
                opacity: 0.6,
                minWidth: 0,
                "&.Mui-selected": { opacity: 1, color: "var(--text-color)" },
              },
            }}
          >
            {[contractName1, contractName2, contractName3].map(
              (label, index) => (
                <Tab
                  key={label}
                  value={[contractName1, contractName2, contractName3][index]}
                  label={label}
                />
              )
            )}
          </Tabs>
        )}

        <Stack direction="row" spacing={1} sx={{ px: 2, py: 2 }}>
          {["Isolated", "Cross"].map((mode) => (
            <Button
              key={mode}
              onClick={() => handleSelect(mode)}
              sx={{
                backgroundColor: selected === mode ? btncolor : "transparent",
                color: selected === mode ? "#fff" : "var(--text-color)",
                borderRadius: "8px",
                padding: "6px 24px",
                textTransform: "none",
                fontWeight: 700,
                fontSize: "0.9rem",
                border:
                  selected === mode
                    ? "none"
                    : "1px solid rgba(125,125,125,0.3)",
                "&:hover": {
                  backgroundColor:
                    selected === mode ? btncolor : "rgba(125,125,125,0.1)",
                },
                minWidth: 140,
              }}
              startIcon={
                selected === mode ? <CheckCircleIcon fontSize="small" /> : null
              }
            >
              {mode}
            </Button>
          ))}
        </Stack>

        <Box sx={{ px: 2, pb: 2 }}>
          <TableContainer
            className="wallet_table"
            sx={{
              p: 2,
              my: 2,
              borderRadius: "10px",
              border: "1px solid rgba(125,125,125,0.15)",
            }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow sx={modernTableHeadRow}>
                  <TableCell sx={modernTableHeadCell}>Contract Name</TableCell>
                  <TableCell sx={modernTableHeadCell}>Balance</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {portfolioBalanceForFuturePerpetual?.length !== 0 ? (
                  portfolioBalanceForFuturePerpetual?.map((p, i) => (
                    <TableRow sx={modernTableBodyRow}>
                      <TableCell sx={modernTableBodyCell}>
                        {p?.assetPair}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p?.amount}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={2}
                      className="text-start"
                      sx={modernTableBodyCell}
                    >
                      No Data
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TableContainer
            className="wallet_table bottom_t"
            sx={{
              p: 2,
              my: 2,
              borderRadius: "10px",
              border: "1px solid rgba(125,125,125,0.15)",
            }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow sx={modernTableHeadRow}>
                  {portfolioHeadersForFuture?.map(
                    (label, i) =>
                      label !== "FULL NAME" && (
                        <TableCell sx={modernTableHeadCell} key={i}>
                          {label}
                        </TableCell>
                      )
                  )}
                  <TableCell sx={modernTableHeadCell}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {portfolioValueForFutureContract1?.length !== 0 ? (
                  portfolioValueForFutureContract1?.map((p, i) => (
                    <TableRow key={i} sx={modernTableBodyRow}>
                      <TableCell sx={modernTableBodyCell}>
                        {p.mpTransactionId}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p.transactionDate}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p.currencyName}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p.baseCurrency}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p.amount}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}> {p.price}</TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p.portfolioType}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p.assetPair}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p.leverage}
                      </TableCell>
                      <TableCell sx={modernTableBodyCell}>
                        {" "}
                        {p.transactionType === 2 && (
                          <ContainedButton
                            variant="contained"
                            size="small"
                            onClick={() =>
                              modalbuyForFuture(
                                p.amount,
                                p.currencyName,
                                p.baseCurrency,
                                p.assetCode,
                                p.mpTransactionId,
                                p.assetPair,
                                p.leverage,
                                "buy"
                              )
                            }
                          >
                            Buy
                          </ContainedButton>
                        )}
                        {p.transactionType === 1 && (
                          <ContainedButton
                            variant="contained"
                            size="small"
                            onClick={() =>
                              modalbuyForFuture(
                                p.amount,
                                p.currencyName,
                                p.baseCurrency,
                                p.assetCode,
                                p.mpTransactionId,
                                p.assetPair,
                                p.leverage,
                                "sell"
                              )
                            }
                          >
                            Sell
                          </ContainedButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={10}
                      className="text-start"
                      sx={modernTableBodyCell}
                    >
                      No Data
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      <ModalContent
        open={marginModal}
        onClose={handleCloseMarginModal}
        title={`Margin`}
      >
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", alignItems: "center", mt: 2 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Amount available:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={amount}
              readOnly
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Send amount:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={sendAmount}
              onChange={(e) => setSendAmount(e.target.value)}
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => validateNumber(e)}
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton variant="outlined" onClick={handleCloseMarginModal}>
            Close
          </OutlinedButton>
          {sendAmount &&
            0 < Number(sendAmount) &&
            Number(sendAmount) <= amount && (
              <ContainedButton
                variant="contained"
                sx={{ mx: 2 }}
                onClick={assetlendingPrice}
              >
                Send
              </ContainedButton>
            )}
        </Box>
      </ModalContent>

      <ModalContent
        open={marginSpotModal}
        onClose={handleCloseMarginSpotModal}
        title={`Transfer To Spot`}
      >
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", alignItems: "center", mt: 2 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Amount available:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={amount}
              readOnly
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Send amount:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={sendAmountMargin}
              onChange={(e) => setSendAmountMargin(e.target.value)}
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => validateNumber(e)}
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton
            variant="outlined"
            onClick={handleCloseMarginSpotModal}
          >
            Close
          </OutlinedButton>
          {sendAmountMargin &&
            0 < Number(sendAmountMargin) &&
            Number(sendAmountMargin) <= amount && (
              <ContainedButton
                variant="contained"
                sx={{ mx: 2 }}
                onClick={fiatholdingPrice}
              >
                Send
              </ContainedButton>
            )}
        </Box>
      </ModalContent>

      <ModalContent
        open={fundingModal}
        onClose={handleCloseFundingModal}
        title={`Funding`}
      >
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", alignItems: "center", mt: 2 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Amount available:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={amount}
              readOnly
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Send amount:</Grid>
          <Grid size={{ xs: 10, sm: 12, md: 6 }}>
            <input
              type="number"
              className="beneficial_dropdown"
              style={{ borderRadius: "0px" }}
              inputMode="numeric"
              value={sendAmountFunding}
              onChange={(e) => setSendAmountFunding(e.target.value)}
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => validateNumber(e)}
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 2, md: 2 }}>
            {cryptoCurrency?.toUpperCase()}
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>Return Date:</Grid>
          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD-MM-YYYY"
                value={returnDate}
                minDate={dayjs()}
                onChange={(newValue) => setReturnDate(newValue)}
                slots={{
                  openPickerIcon: CalendarMonthIcon,
                }}
                // sx={{
                //   backgroundColor: theme === "dark" ? "#0F111A" : "#a89f9f",
                // }}
                slotProps={{
                  textField: {
                    placeholder: "dd-mm-yyyy",
                    fullWidth: true,
                    // sx: {
                    //   backgroundColor: "#0F111A",
                    //   input: { color: "#B0B3B8" }, // text color
                    //   svg: { color: "#B0B3B8" }, // icon color
                    //   borderRadius: 1,
                    // },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 2 }} />
        </Grid>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton variant="outlined" onClick={handleCloseFundingModal}>
            Close
          </OutlinedButton>
          {sendAmountFunding &&
            0 < Number(sendAmountFunding) &&
            Number(sendAmountFunding) <= amount &&
            returnDate && (
              <ContainedButton
                variant="contained"
                sx={{ mx: 2 }}
                onClick={assetfundBuy}
              >
                Submit
              </ContainedButton>
            )}
        </Box>
      </ModalContent>

      <ModalContent
        open={customerFundingModal}
        onClose={handleCustomerFundingModalClose}
        title={`Customer Funding Details View`}
      >
        <TableContainer className="wallet_table bottom_t" sx={{ p: 2, my: 2 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow sx={modernTableHeadRow}>
                <TableCell sx={modernTableHeadCell}>Currency Name</TableCell>
                <TableCell sx={modernTableHeadCell}>Lending Date</TableCell>
                <TableCell sx={modernTableHeadCell}>Return Date</TableCell>
                <TableCell sx={modernTableHeadCell}>Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fdata?.length != 0 ? (
                fdata?.map((d, i) => (
                  <TableRow key={i} sx={modernTableBodyRow}>
                    <TableCell sx={modernTableBodyCell}>
                      {d?.currencyName}
                    </TableCell>
                    <TableCell sx={modernTableBodyCell}>
                      {" "}
                      {d?.lendingDate}
                    </TableCell>
                    <TableCell sx={modernTableBodyCell}>
                      {" "}
                      {d?.returnDate}
                    </TableCell>
                    <TableCell sx={modernTableBodyCell}> {d?.amount}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} sx={modernTableBodyCell}>
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box display="flex" justifyContent="center" mt={2}>
          <OutlinedButton
            variant="outlined"
            onClick={handleCustomerFundingModalClose}
          >
            Close
          </OutlinedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={buyModal}
        onClose={handleBuyClose}
        title={`Buy Offer`}
      >
        <p className="text-center text-secondary mt-3">
          Are you sure you want to place this Buy offer?
        </p>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton variant="outlined" onClick={handleBuyClose}>
            No
          </OutlinedButton>

          <ContainedButton
            variant="contained"
            sx={{ mx: 2 }}
            onClick={portfolioholdingBuyForFuture}
          >
            Yes
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={sellModal}
        onClose={handleSellClose}
        title={`Sell Offer`}
      >
        <p className="text-center text-secondary mt-3">
          Are you sure you want to place this sell offer?
        </p>
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <OutlinedButton variant="outlined" onClick={handleSellClose}>
            No
          </OutlinedButton>

          <ContainedButton
            variant="contained"
            sx={{ mx: 2 }}
            onClick={portfolioholdingSellForFuture}
          >
            Yes
          </ContainedButton>
        </Box>
      </ModalContent>

      <InfoPopUp
        open={infoModal}
        onClose={handleCloseInfoModal}
        title={Infomodal[infoIndex]?.title}
        description={Infomodal[infoIndex]?.description}
      />
    </Box>
  );
};

// ── Design System Styles ──────────────────────────────────────────────────────
const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};
const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};
const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};
const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};
const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};
const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};
const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};
const sectionCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  overflow: "hidden",
  mb: 2,
};
const cardSectionTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
  letterSpacing: "-0.01em",
};
const sectionHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: 2,
  py: 1.5,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
};
const modernTableHeadRow = { backgroundColor: "var(--body-color-less2)" };
const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
  backgroundColor: "var(--body-color-less2)",
};
const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};
const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};
// ─────────────────────────────────────────────────────────────────────────────

export default MyWalletFuture;
